;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cva } from 'class-variance-authority'

export const buttonStyles = cva(
  'font-outfit inline-flex cursor-pointer items-center justify-center gap-2 rounded-sm disabled:cursor-not-allowed aria-disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        contained:
          'bg-gray-800 tracking-wider text-gray-50 hover:bg-gray-700 active:bg-gray-900 disabled:bg-gray-200 disabled:text-gray-700 aria-disabled:bg-gray-200 aria-disabled:text-gray-700 aria-disabled:hover:bg-gray-200 aria-disabled:active:bg-gray-200',
        // `inset-ring` helps us to not having to apply a border on the button and then have to remove it when it's not needed. It also prevents the button, when border is applied to take more space than those without any border.
        outlined:
          'bg-white text-gray-800 inset-ring inset-ring-gray-800 hover:bg-gray-100 active:bg-gray-100 active:shadow-[inset_0px_4px_32px_rgba(0,0,0,0.05)] disabled:bg-white disabled:text-gray-500 disabled:shadow-none disabled:inset-ring-gray-500 aria-disabled:bg-white aria-disabled:text-gray-500 aria-disabled:shadow-none aria-disabled:inset-ring-gray-500 aria-disabled:hover:bg-white aria-disabled:active:bg-white aria-disabled:active:shadow-none',
        danger:
          'bg-error-700 hover:bg-error-800 active:bg-error-900 focus-visible:bg-error-800 text-white disabled:bg-gray-200 disabled:text-gray-700 aria-disabled:bg-gray-200 aria-disabled:text-gray-700 aria-disabled:hover:bg-gray-200 aria-disabled:active:bg-gray-200',
        inverse:
          'bg-white text-gray-700 hover:bg-gray-50 active:bg-gray-50 active:shadow-[inset_0px_4px_32px_rgba(0,0,0,0.05)] disabled:bg-gray-200 disabled:shadow-none aria-disabled:bg-gray-200 aria-disabled:shadow-none aria-disabled:hover:bg-gray-200 aria-disabled:active:bg-gray-200 aria-disabled:active:shadow-none',
        text: 'py-2 text-gray-700 underline underline-offset-4 hover:text-gray-900 disabled:text-gray-500 aria-disabled:text-gray-500 aria-disabled:hover:text-gray-500',
        'inline-text':
          'underline underline-offset-4 hover:text-gray-900 disabled:text-gray-500 aria-disabled:text-gray-500 aria-disabled:hover:text-gray-500',
      },
      size: {
        small: 'text-sm',
        medium: 'text-base',
        responsive: 'text-sm sm:text-base',
        inline: '[font-size:inherit] [font-weight:inherit]',
      },
    },
    compoundVariants: [
      {
        size: ['small'],
        variant: ['contained', 'outlined', 'inverse', 'danger'],
        className: 'min-h-11 px-6 py-2.5', // min-h is to make height consistent with/without icons
      },
      {
        size: ['medium'],
        variant: ['contained', 'outlined', 'inverse', 'danger'],
        className: 'min-h-14 px-6 py-3.5', // min-h is to make height consistent with/without icons
      },
      {
        size: ['responsive'],
        variant: ['contained', 'outlined', 'inverse', 'danger'],
        className: 'min-h-11 px-6 py-2.5 sm:min-h-14 sm:py-3.5', // min-h is to make height consistent with/without icons
      },
    ],
    defaultVariants: {
      variant: 'contained',
      size: 'medium',
    },
  },
)
